// const BASE_URL = "https://staging.pteshstudios.com";

import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";
import { CiEdit } from "react-icons/ci";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "",
  paragraphs: [],
  sections: [],
};

export default function Installments() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/installation-instrumentation", DEFAULT_DATA);

  const bannerImg  = resolveUrl(pageData.bannerImage) || null;
  const bgImg      = resolveUrl(pageData.bgImage)     || null;
  const hasContent = Boolean(pageData.title);

  return (
    <>
      {/* <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button> */}

      
      <button
        title="Edit page"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: 70, right: 20, zIndex: 10, background: "rgba(255,255,255,0.9)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
      >
        <CiEdit size={24} color="#333" />
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Installation & Instrumentation" />
      )}

      {hasContent && (
        <>
          {bannerImg && (
            <div className="img_carrierins">
              <img src={bannerImg} alt="" />
            </div>
          )}

          <section className="service-detail" style={bgImg ? { backgroundImage: `url(${bgImg})` } : {}}>
            <div className="service-detail__layout">
              <div className="service-detail__content">
                <h2 className="service-detail__title">{pageData.title}</h2>
                <span className="service-detail__divider" />
                {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
                {pageData.sections.map((sec, i) => (
                  <div key={i} className="service-detail__section">
                    <h3 className="service-detail__section-heading">{sec.heading}</h3>
                    <ul className="service-detail__list">
                      {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                    </ul>
                  </div>
                ))}
              </div>
              <nav className="service-detail__tabs" aria-label="Service navigation">
                {servicesNav.map((s) => (
                  <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                    {s.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          </section>
        </>
      )}
    </>
  );
}